var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{ref:"table",attrs:{"headers":_vm.headers,"items":_vm.tableData,"sort-by":"name"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h2',{staticClass:"ml-4"},[_vm._v("Tresore")])]},proxy:true},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":("/safe/" + (item.id))}},[_vm._v(_vm._s(item.name))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }